// extracted by mini-css-extract-plugin
export default {"sidebar":"w_b3","sidebarHeader":"w_b4","fileinput":"w_b5","form":"w_b6","sponsoredText":"w_cd"};